import { getMapIconUrls } from '../../config/publicIcons.config'
import AppIcon from '../icons/AppIcon'
import styles from './MapScreen.module.css'

const markerIconUrl = getMapIconUrls().locationRed

function PlayerMarker({ size = 20, isLeader = false }: { size?: number; isLeader?: boolean }) {
  return (
    <div className={styles.markerWrap}>
      {isLeader && (
        <AppIcon icon="solar:crown-bold" size={size * 1.2} className={styles.markerLeader} />
      )}
      <img
        src={markerIconUrl}
        alt={isLeader ? 'Leader' : 'Your position'}
        className={styles.markerIcon}
        style={{ width: size }}
      />
    </div>
  )
}

function PaceSetterMarker({ size = 20 }: { size?: number }) {
  return (
    <img
      src={markerIconUrl}
      alt="Pace Setter"
      className={[styles.markerIcon, styles.paceMarker].join(' ')}
      style={{ width: size }}
    />
  )
}

export interface MapLegendProps {
  yourProgress: number
  leaderProgress: number
}

export default function MapLegend({ yourProgress, leaderProgress }: MapLegendProps) {
  const isLeader = yourProgress >= leaderProgress

  return (
    <div className={styles.mapLegend}>
      <div className={styles.legendRow}>
        <PlayerMarker size={12} isLeader={isLeader} />
        <span className={styles.legendLabel}>You</span>
      </div>
      {!isLeader && (
        <div className={styles.legendRow}>
          <PlayerMarker size={12} isLeader />
          <span className={styles.legendLabel}>Leader</span>
        </div>
      )}
      <div className={styles.legendRow}>
        <PaceSetterMarker size={12} />
        <span className={styles.legendLabel}>Pace Setter</span>
      </div>
    </div>
  )
}

export { PlayerMarker, PaceSetterMarker }
